(() => {
  const sectionSelector = '#MainContent > .shopify-section';
  const mediaSelector = [
    '.grid-product__image-mask',
    '.aspyr-image-product__media',
    '.aspyr-tab-card__media',
    '.aspyr-showcase-card__media',
    '.aspyr-product-media',
    '.collection-image',
    '.collection-image-wrap',
    '.image-wrap',
    '.background-media-text__image',
    '.hero__image-wrapper'
  ].join(',');

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const animationsDisabled = document.body.dataset.disableAnimations === 'true';
  let observer;

  const reveal = (element) => {
    element.classList.add('is-aspyr-revealed');
    if (observer) observer.unobserve(element);
  };

  const register = (element, type, delay = 0) => {
    if (!element || element.dataset.aspyrRevealReady === 'true') return;
    if (type === 'media' && element.closest('[data-aos]')) return;
    element.dataset.aspyrReveal = type;
    element.dataset.aspyrRevealReady = 'true';
    element.style.setProperty('--aspyr-reveal-delay', `${delay}ms`);

    if (animationsDisabled || reducedMotion.matches || !observer) {
      reveal(element);
      return;
    }

    observer.observe(element);
  };

  const registerSection = (section) => {
    if (!section || !section.matches(sectionSelector)) return;
    register(section, 'section');

    section.querySelectorAll(mediaSelector).forEach((media, index) => {
      register(media, 'media', Math.min(index % 5, 4) * 45);
    });
  };

  const scan = (root = document) => {
    if (root.matches && root.matches(sectionSelector)) registerSection(root);
    root.querySelectorAll?.(sectionSelector).forEach(registerSection);

    if (root !== document && root.querySelectorAll) {
      if (root.matches?.(mediaSelector)) register(root, 'media');
      root.querySelectorAll(mediaSelector).forEach((media, index) => {
        register(media, 'media', Math.min(index % 5, 4) * 45);
      });
    }
  };

  document.documentElement.classList.add('aspyr-scroll-reveal-enabled');

  if (!animationsDisabled && !reducedMotion.matches && 'IntersectionObserver' in window) {
    observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) reveal(entry.target);
      });
    }, {
      rootMargin: '0px 0px -9% 0px',
      threshold: 0.08
    });
  }

  scan();

  const main = document.getElementById('MainContent');
  if (main && 'MutationObserver' in window) {
    const mutationObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) scan(node);
        });
      });
    });
    mutationObserver.observe(main, { childList: true, subtree: true });
  }

  document.addEventListener('shopify:section:load', (event) => scan(event.target));
  document.addEventListener('shopify:section:select', (event) => {
    event.target.querySelectorAll?.('[data-aspyr-reveal]').forEach(reveal);
    if (event.target.matches?.('[data-aspyr-reveal]')) reveal(event.target);
  });
})();
